import { render } from "./ContactComponent.vue?vue&type=template&id=9be853ca&ts=true"
import script from "./ContactComponent?vue&type=script&lang=ts"
export * from "./ContactComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/xebel/xebel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__